export enum TopPanelContainerType {
  lobby,
  game,
}
